<template>
  <div class="container-main">
    <button class="return-button" @click="goToHome(false)">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-arrow-left-circle"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
        />
      </svg>
      Retour
    </button>

    <div class="form-container">
      <div class="contact-form">
        <div class="contact-equipe">
          <h2>Prenez contact avec notre équipe, nous reviendrons vers vous</h2>
        </div>

        <form @submit.prevent="validateAndSubmit">
          <!-- Group Nom and Prénom fields in a single row -->
          <div class="form-row">
            <div class="form-group">
              <label for="nom">Nom: <span class="required">*</span></label>
              <input
                type="text"
                id="nom"
                v-model="form.nom"
                required
                @blur="validateField('nom')"
                :class="{'input-error': errors.nom}"
              />
              <span v-if="errors.nom" class="error-message">{{ errors.nom }}</span>
            </div>

            <div class="form-group">
              <label for="prenom">Prénom: <span class="required">*</span></label>
              <input
                type="text"
                id="prenom"
                v-model="form.prenom"
                required
                @blur="validateField('prenom')"
                :class="{'input-error': errors.prenom}"
              />
              <span v-if="errors.prenom" class="error-message">{{ errors.prenom }}</span>
            </div>
          </div>

          <div class="form-group">
            <label for="email">Email: <span class="required">*</span></label>
            <input
              type="email"
              id="email"
              v-model="form.email"
              required
              @blur="validateField('email')"
              :class="{'input-error': errors.email}"
            />
            <span v-if="errors.email" class="error-message">{{ errors.email }}</span>
          </div>

          <div class="form-group">
            <label for="telephone">Téléphone: <span class="required">*</span></label>
            <input
              type="tel"
              id="telephone"
              v-model="form.telephone"
              required
              @blur="validateField('telephone')"
              :class="{'input-error': errors.telephone}"
            />
            <span v-if="errors.telephone" class="error-message">{{ errors.telephone }}</span>
          </div>

          <div class="form-group">
            <label for="cabinet">Entreprise/Cabinet: <span class="required">*</span></label>
            <input
              type="text"
              id="cabinet"
              v-model="form.cabinet"
              required
              @blur="validateField('cabinet')"
              :class="{'input-error': errors.cabinet}"
            />
            <span v-if="errors.cabinet" class="error-message">{{ errors.cabinet }}</span>
          </div>

          <div class="form-group">
            <label for="message">Message (optionnel):</label>
            <textarea
              id="message"
              v-model="form.message"
              rows="4"
              placeholder="Votre message..."
            ></textarea>
          </div>

          <div class="required-note">
            <span class="required">*</span> Tous les champs sont obligatoires
          </div>

          <button class="sub-button" type="submit">
            <span v-if="isSubmitting">
              <span class="spinner"></span> Envoi en cours...
            </span>
            <span v-else>Soumettre</span>
          </button>

          <div v-if="responseMessage" class="response-message" :class="{ 'success': isSuccess, 'error': !isSuccess }">
            {{ responseMessage }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ContactForm",
  data() {
    return {
      form: {
        nom: "",
        prenom: "",
        email: "",
        telephone: "",
        cabinet: "",
        message: "",
      },
      errors: {
        nom: "",
        prenom: "",
        email: "",
        telephone: "",
        cabinet: "",
      },
      responseMessage: "",
      isSubmitting: false,
      isSuccess: false,
    };
  },
  methods: {
    validateField(field) {
      this.errors[field] = "";

      // Check if empty
      if (!this.form[field].trim()) {
        this.errors[field] = `Ce champ est obligatoire`;
        return false;
      }

      // Additional validation for specific fields
      if (field === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.form.email)) {
          this.errors.email = "Veuillez entrer une adresse email valide";
          return false;
        }
      }

      return true;
    },

    validateForm() {
      let isValid = true;

      // Validate all fields
      for (const field in this.form) {
        if (!this.validateField(field)) {
          isValid = false;
        }
      }

      return isValid;
    },

    validateAndSubmit() {
      if (this.validateForm()) {
        this.submitForm();
      } else {
        this.responseMessage = "Veuillez remplir tous les champs obligatoires correctement.";
        this.isSuccess = false;
      }
    },

    async submitForm() {
      this.isSubmitting = true;
      try {
        const response = await axios.post("https://api.query-juriste.com/copilot/contact", this.form);
        if (response.data.res === "done") {
          this.responseMessage = "Votre message a bien été envoyé!";
          this.isSuccess = true;
          this.clearForm();
        } else {
          this.responseMessage = "Une erreur est survenue lors de l'envoi de votre message.";
          this.isSuccess = false;
        }
      } catch (error) {
        this.responseMessage = "Une erreur s'est produite. Veuillez réessayer plus tard.";
        this.isSuccess = false;
        console.error("Error submitting form:", error);
      } finally {
        this.isSubmitting = false;
      }
    },

    clearForm() {
      // Reset form data
      for (const field in this.form) {
        this.form[field] = "";
      }

      // Reset error messages
      for (const field in this.errors) {
        this.errors[field] = "";
      }

      // Attendre un peu pour que l'utilisateur puisse voir le message de succès
      setTimeout(() => {
        this.goToHome(true);
      }, 1500);
    },

    goToHome(sendMessage) {
      if (sendMessage) {
        this.$router.push({
          path: '/dashboardPage',
          query: {
            fromContact: true,
            message: this.responseMessage
          }
        });
      } else {
        this.$router.push('/dashboardPage');
      }
    },
  },
};
</script>

<style scoped>
.container-main {
  background-color: #F5F6FA;
  font-family: "Roboto", sans-serif;
  padding: 2em;
  min-height: 100vh;
  width: 100%;
}

.return-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  transition: all 0.2s ease;
  border-radius: 20px;
}

.return-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.return-button svg {
  margin-right: 8px;
}

.form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 85vh;
}

.contact-form {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  background-color: white;
  width: 40%;
  padding: 2.5em;
  margin: 2em auto;
  border-radius: 12px;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5em;
}

.logo-image {
  width: 90px;
  height: 75px;
  transition: transform 0.3s ease;
}

.logo-image:hover {
  transform: scale(1.05);
}

/* New class to arrange Nom and Prénom side by side */
.form-row {
  display: flex;
  gap: 1.5rem; /* Space between fields */
}

.form-group {
  margin-bottom: 1.5rem;
  flex: 1; /* Ensures each field in a row takes equal space */
}

label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 0.95rem;
}

input,
textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #6c63ff;
  box-shadow: 0 0 0 2px rgba(108, 99, 255, 0.1);
}

.input-error {
  border-color: #e53935 !important;
  background-color: rgba(229, 57, 53, 0.05);
}

.error-message {
  color: #e53935;
  font-size: 0.8rem;
  margin-top: 0.3rem;
  display: block;
}

.required {
  color: #e53935;
  font-weight: bold;
}

.required-note {
  font-size: 0.85rem;
  margin-bottom: 1.5rem;
  color: #666;
}

.sub-button {
  display: block;
  width: 100%;
  padding: 0.9rem;
  background-color: #6c63ff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  transition: background-color 0.3s, transform 0.2s;
  margin-top: 0.5rem;
}

.sub-button:hover {
  background-color: #5a54d1;
  transform: translateY(-2px);
}

.sub-button:active {
  transform: translateY(0);
}

.response-message {
  margin-top: 1.5rem;
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
  font-weight: 500;
}

.success {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.error {
  background-color: #ffebee;
  color: #c62828;
}

.contact-equipe {
  text-align: center;
  margin-bottom: 2em;
}

.contact-equipe h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

/* Spinner for loading state */
.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  margin-right: 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive styles */
@media (max-width: 768px) {
  .contact-form {
    width: 90%;
    padding: 1.5em;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .contact-equipe h2 {
    font-size: 1.3rem;
  }
}
</style>
